import type { AllCMSPageFields } from '@/cms/fields/mappers/common'
import * as React from 'react'

export const PageFieldsContext = React.createContext<AllCMSPageFields | null>(null)
